import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import BlockArea from 'features/BlockArea';
import { BLOCKS } from 'constants/blockTypes';
import { connect } from 'react-redux';

class CountyContentAreaBlock extends React.PureComponent {
  render() {
    const { blockContentArea, showMenuBlock, opacity } = this.props;

    const newBlockContentArea = [];
    let addedMenuBlock = false;

    if (blockContentArea !== null) {
      blockContentArea.forEach(block => {
        if (block.blockType !== 'MenuBlock') {
          newBlockContentArea.push(block);
        } else if (showMenuBlock && !addedMenuBlock) {
          newBlockContentArea.push(block);
          addedMenuBlock = true;
        }
      });
    }

    return (
      <div className="county-content-area-block" role="region" aria-label="Regionalt innehåll">
        <Fragment>
          <BlockArea
            propertyName="blockContentArea"
            contentarea={newBlockContentArea}
            opacity={opacity}
            renderInline={true}
            nomargin
          />
        </Fragment>
      </div>
    );
  }
}

CountyContentAreaBlock.propTypes = {
  blockType: PropTypes.oneOf([BLOCKS.COUNTY_CONTENT_AREA_BLOCK]),
  blockContentArea: PropTypes.array,
  showMenuBlock: PropTypes.bool,
  opacity: PropTypes.number
};

CountyContentAreaBlock.defaultProps = {
  blockContentArea: [],
  showMenuBlock: false,
  opacity: 1,
  category: []
};

const mapStateToProps = ({ filter }) => ({
  filter: {
    selectedId: filter && filter.selected ? filter.selected.id : undefined
  },
  forceMode: filter ? filter.forceMode : undefined
});

export default connect(mapStateToProps)(CountyContentAreaBlock);
